import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "agent-output-fields" }
const _hoisted_2 = { class: "output-head" }
const _hoisted_3 = {
  class: "output-grid",
  role: "table",
  "aria-label": "Output fields"
}
const _hoisted_4 = {
  class: "grid-header",
  role: "row"
}
const _hoisted_5 = {
  key: 0,
  class: "empty-row",
  role: "row"
}
const _hoisted_6 = { role: "cell" }
const _hoisted_7 = { role: "cell" }
const _hoisted_8 = { role: "cell" }
const _hoisted_9 = { role: "cell" }
const _hoisted_10 = {
  class: "row-actions",
  role: "cell"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Button = _resolveComponent("Button")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_AddOutput = _resolveComponent("AddOutput")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Ellipsis, { class: "label" }, {
        default: _withCtx(() => [
          _createTextVNode("Output fields (" + _toDisplayString($options.output_entries.length) + "/" + _toDisplayString($data.max_output_fields) + ")", 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Button, {
        tiny: "",
        disabled: $options.output_entries.length >= $data.max_output_fields,
        onClick: $options.addOutput
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Add field")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Ellipsis, { role: "columnheader" }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Name")
          ])),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_Ellipsis, { role: "columnheader" }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Type")
          ])),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_Ellipsis, { role: "columnheader" }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Optional")
          ])),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_Ellipsis, { role: "columnheader" }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("Description")
          ])),
          _: 1 /* STABLE */
        }),
        _cache[5] || (_cache[5] = _createElementVNode("div", {
          role: "columnheader",
          "aria-label": "Actions"
        }, null, -1 /* HOISTED */))
      ]),
      (!$options.output_entries.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[6] || (_cache[6] = [
            _createElementVNode("div", {
              class: "empty-state",
              role: "cell",
              "aria-colspan": "5"
            }, " No output fields yet ", -1 /* HOISTED */)
          ])))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.output_entries, (entry, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: entry.name,
          class: "output-row",
          role: "row"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Ellipsis, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(entry.name), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(entry.type), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_8, _toDisplayString(entry.optional ? 'Yes' : 'No'), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Ellipsis, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(entry.description || '—'), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_IconAsButton, {
              icon: "edit-03",
              color: "--gray-600",
              tooltip: "Edit output field",
              onClick: $event => (_ctx.$refs.editor.open(entry, index))
            }, null, 8 /* PROPS */, ["onClick"]),
            _createVNode(_component_IconAsButton, {
              icon: "trash-04",
              color: "--gray-600",
              tooltip: "Remove output field",
              onClick: $event => ($options.removeOutput(index))
            }, null, 8 /* PROPS */, ["onClick"])
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode(_component_AddOutput, {
      ref: "editor",
      entries: $options.output_entries,
      onSubmit: $options.saveOutput
    }, null, 8 /* PROPS */, ["entries", "onSubmit"])
  ]))
}